import React, {
  useEffect,
  useState,
} from "react";

import jwt_decode from "jwt-decode";
import { FaTruck } from "react-icons/fa";

import AddComanda from "../components/AddComanda";
import TableComandas from "../components/TableComandas";
import Footer from "../components/Footer";

import "../css/admin.css";
import "../css/tablecomandas.css";

const Comandas = () => {
  const [usuario, setUsuario] =
    useState({});

  const [show, setShow] =
    useState(false);

  const token =
    localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode =
          jwt_decode(token);

        setUsuario(
          token_decode.usuario
        );
      } catch (e) {
        console.error(
          "❌ Error al decodificar token:",
          e
        );

        setUsuario({});
      }
    }
  }, [token]);

  return (
    <>
      <main className="cmd-page">
        {token ? (
          usuario?.role ===
          "ADMIN_ROLE" ? (
            <>
              <section className="cmd-header">
                <div className="cmd-header-icon">
                  <FaTruck />
                </div>

                <div className="cmd-header-text">
                  <span>
                    OPERACIÓN
                  </span>

                  <h1>
                    Gestión de Viajes
                  </h1>

                  <p>
                    Administración y seguimiento
                    de comandas, viajes y
                    documentación de transporte.
                  </p>
                </div>
              </section>

              <div className="cmd-actions">
                <AddComanda
                  setShow={setShow}
                  show={show}
                />
              </div>

              {!show && (
                <TableComandas />
              )}
            </>
          ) : (
            <div
              className="alert alert-info"
              role="alert"
            >
              Lo sentimos, pero no tiene
              permisos para acceder a este
              contenido.
            </div>
          )
        ) : (
          <div
            className="alert alert-danger"
            role="alert"
          >
            No se encuentra logueado en la
            plataforma.
          </div>
        )}
      </main>

      <Footer />
    </>
  );
};

export default Comandas;